<template>
  <div>
    <a-card class="workflow-info" :loading="loading">
      <div v-if="!loading">
        <a-page-header sub-title="流程详情" @back="() => $router.go(-1)">
          <template slot="title">
            <a-tooltip placement="topLeft" :title="workflowData.title">
              <span class="page-header_title">{{ workflowData.title }}</span>
            </a-tooltip>
          </template>
          <template slot="tags">
            <span v-if="workflowData.no_need_qa === 1" class="gold-span">免验</span>
          </template>
          <template slot="extra">
            <a-button v-if="showAccurate" v-tc="{ name: '精准生产对比' }" size="small" icon="eye" @click="onOnlineAccurate">生产对比</a-button>
            <a-button v-tc="{ name: '查看配置' }" size="small" @click="onConfigConfirmItem"><a-icon type="audit" /> 查看配置</a-button>
            <a-button v-if="[14, 17].includes(workflowData.workflow_template.id)" v-tc="{ name: '测试报告' }" size="small" type="dashed" icon="schedule" @click="onTestReport"> 测试报告 </a-button>
            <a-dropdown>
              <a-menu slot="overlay">
                <template v-if="modifyStatus === false && workflowData.associable_status !== 2">
                  <a-menu-item key="1" v-tc="{ name: '终止流程' }" @click="onStop"><a-icon type="poweroff" /> 终止流程 </a-menu-item>
                  <a-menu-item key="2" v-tc="{ name: '编辑流程' }" @click="onEdit"><a-icon type="edit" /> 编辑流程 </a-menu-item>
                </template>
                <a-menu-item v-if="workflowData.fast_create" key="3" v-tc="{ name: '创建下一阶段流程' }" @click="onFastCreate"><a-icon type="poweroff" /> 创建下一阶段流程 </a-menu-item>
                <a-menu-item v-if="workflowData.associable_permission === true && workflowData.associable_status === 1" key="4" v-tc="{ name: '关联流程' }" @click="onSociatedWorkflow">关联流程</a-menu-item>
                <a-menu-item key="4" v-tc="{ name: '查看配置' }" @click="onConfigConfirmItem"><a-icon type="audit" /> 查看配置 </a-menu-item>
                <template v-if="false">
                  <a-menu-item v-if="workflowData.workflow_template.id == 13" key="5" v-tc="{ name: '获取覆盖率信息' }" @click="viewCoverInfo"><a-icon type="file-protect" />获取覆盖率信息</a-menu-item>
                </template>
              </a-menu>
              <a-button size="small" type="primary" style="margin-left: 8px"> 更多 <a-icon type="down" /> </a-button>
            </a-dropdown>
          </template>
          <a-alert v-if="workflowData.associable_status === 2" banner style="margin-bottom: 8px">
            <span slot="message">
              <span>当前流程已被关联，无法对流程进行操作，您可以 <a :href="workflowLink(workflowData.parent_project, workflowData.parent_id)" target="_blank">查看关联流程</a></span>
              <span v-if="[1].includes(workflowData.status.value)">，或 <a v-tc="{ name: '解除关联' }" @click="onDisassociation">解除关联</a></span>
            </span>
          </a-alert>
          <a-descriptions size="small">
            <a-descriptions-item label="流程模板"> {{ workflowData.workflow_template.name }} </a-descriptions-item>
            <a-descriptions-item label="流程类型"> {{ workflowData.workflow_type.label }} </a-descriptions-item>
            <a-descriptions-item label="流程状态">
              <a-badge :status="workflowStatus[workflowData.status.value].status" :text="workflowStatus[workflowData.status.value].label" />
            </a-descriptions-item>
            <a-descriptions-item label="创建人员">
              <user-profiles :value="[workflowData.creator.user_id]" avatar />
            </a-descriptions-item>
            <a-descriptions-item label="创建时间"> {{ workflowData.created_time }} </a-descriptions-item>
            <a-descriptions-item label="更新时间"> {{ workflowData.updated_time }} </a-descriptions-item>
          </a-descriptions>
          <a-descriptions size="small">
            <a-descriptions-item v-for="(userItems, index) in workflowData.workflow_users" :key="index" :label="userItems.role_name">
              <user-profiles :value="userItems.users.map(el => el.user_id)" avatar />
            </a-descriptions-item>
          </a-descriptions>
          <a-descriptions class="ant-descriptions-vertical">
            <a-descriptions-item label="参与团队">
              <span v-for="item in workflowData.workflow_teams" :key="item.id"> {{ item.name }}; </span>
            </a-descriptions-item>
            <a-descriptions-item label="备注信息" :span="2">
              <span style="white-space: pre-wrap">{{ workflowData.description }}</span>
            </a-descriptions-item>
          </a-descriptions>
          <template slot="footer">
            <a-tabs v-model="activeKey" class="footer-tabs">
              <a-tab-pane key="0" tab="详情" />
              <a-tab-pane v-if="workflowMoreInfoData.content.length > 0" key="1">
                <a-badge slot="tab" :count="workflowMoreInfoData.content.length"><span class="head-example">发布内容</span></a-badge>
              </a-tab-pane>
              <a-tab-pane v-if="workflowMoreInfoData.story_list && workflowMoreInfoData.story_list.length > 0 && ![13, 16].includes(workflowData.workflow_template.id)" key="2">
                <a-badge slot="tab" :count="workflowMoreInfoData.story_list.length"><span class="head-example">关联需求</span></a-badge>
              </a-tab-pane>
              <a-tab-pane v-if="workflowMoreInfoData.story_list && workflowMoreInfoData.task_list.length > 0" key="8">
                <a-badge slot="tab" :count="workflowMoreInfoData.task_list.length"><span class="head-example">关联任务</span></a-badge>
              </a-tab-pane>
              <a-tab-pane v-if="(bugListTotal && bugNumTotal > 0) || workflowMoreInfoData.problem_list.length > 0" key="7">
                <a-badge slot="tab" :count="bugNumTotal"><span class="head-example">关联缺陷/问题</span></a-badge>
              </a-tab-pane>
              <a-tab-pane v-if="workflowMoreInfoData.apollo_address.length > 0" key="3">
                <a-badge slot="tab" :count="workflowMoreInfoData.apollo_address.length"><span class="head-example">配置变更</span></a-badge>
              </a-tab-pane>
              <a-tab-pane v-if="workflowMoreInfoData.sql_address.length > 0" key="4">
                <a-badge slot="tab" :count="workflowMoreInfoData.sql_address.length"><span class="head-example">数据变更</span></a-badge>
              </a-tab-pane>
              <a-tab-pane v-if="workflowMoreInfoData.services.length > 0" key="5">
                <a-badge slot="tab" :count="workflowMoreInfoData.services.length" :class="workflowMoreInfoData.processing_services.length > 0 ? 'badge-warning' : 'badge-info'"><span class="head-example">服务列表</span></a-badge>
              </a-tab-pane>
              <a-tab-pane v-if="workflowMoreInfoData.relation_workflow.length > 0" key="6" tab="关联流程" />
            </a-tabs>
          </template>
        </a-page-header>
      </div>
      <div v-else />
    </a-card>
    <div v-show="activeKey === '0'">
      <div style="background-color: #fff">
        <a-skeleton :loading="loading" active />
        <workflow-steps v-if="!loading" :current="workflowData.workflow_current_step.index" :steps="workflowData.workflow_steps" :abstract="workflowData.steps_abstract" :template-id="workflowData.workflow_template ? workflowData.workflow_template.id : null" :current-step-id="workflowData.workflow_current_step.id" />
      </div>
      <workflow-move :project-id="workflowData.project_id" :workflow-id="workflowData.id" :workflow-status="workflowData.status.value" :current-step="workflowData.workflow_current_step" :associable-status="workflowData.associable_status" :processing-services="workflowMoreInfoData.processing_services" :template-id="workflowData.workflow_template ? workflowData.workflow_template.id : null" @onReload="onReload" />
      <workflow-release v-if="!loading && [0, 1].includes(workflowData.workflow_template.level)" :workflow-status="workflowData.status.value" :plan-data="planTableData" />
      <workflow-changelog ref="changelog" />
    </div>
    <workflow-detail-collapse v-show="activeKey === '1'" :data="workflowMoreInfoData.content" />
    <!-- 关联需求TabPane -->
    <a-card v-show="activeKey === '2'">
      <issue-list :data-source="workflowMoreInfoData.story_list || []" />
    </a-card>
    <!-- 关联任务TabPane -->
    <a-card v-show="activeKey === '8'">
      <task-list :data-source="workflowMoreInfoData.task_list || []" />
    </a-card>
    <a-card v-show="activeKey === '7'">
      <a-collapse :active-key="['1', '2', '3']" :bordered="false">
        <template #expandIcon="props">
          <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
        </template>
        <a-collapse-panel v-if="workflowMoreInfoData.bug_list.length > 0" key="1" class="issues-collapse-panel">
          <a-badge slot="header" :count="workflowMoreInfoData.bug_list.length"> <span class="head-example">提审缺陷</span></a-badge>
          <issue-basic-list :issue-list="workflowMoreInfoData.bug_list" />
        </a-collapse-panel>
        <a-collapse-panel v-if="workflowMoreInfoData.reject_bug_list.length > 0" key="2" class="issues-collapse-panel">
          <a-badge slot="header" :count="workflowMoreInfoData.reject_bug_list.length"> <span class="head-example">驳回/退回缺陷</span></a-badge>
          <issue-basic-list :issue-list="workflowMoreInfoData.reject_bug_list" />
        </a-collapse-panel>
        <a-collapse-panel v-if="workflowMoreInfoData.reject_bug_list.length > 0" key="3" class="issues-collapse-panel">
          <a-badge slot="header" :count="workflowMoreInfoData.reject_bug_list.length"> <span class="head-example">验收问题</span></a-badge>
          <issue-basic-list :issue-list="workflowMoreInfoData.reject_bug_list" />
        </a-collapse-panel>
        <a-collapse-panel v-if="workflowMoreInfoData.problem_list.length > 0" key="4" class="issues-collapse-panel">
          <a-badge slot="header" :count="workflowMoreInfoData.problem_list.length"> <span class="head-example">线上问题</span></a-badge>
          <problem-list :data-source="workflowMoreInfoData.problem_list" />
        </a-collapse-panel>
      </a-collapse>
    </a-card>
    <workflow-detail-collapse v-show="activeKey === '3'" :data="workflowMoreInfoData.apollo_address" />
    <workflow-detail-collapse v-show="activeKey === '4'" :data="workflowMoreInfoData.sql_address" />
    <workflow-detail-service v-show="activeKey === '5'" :data-source="workflowMoreInfoData.services" :deploy-permission="workflowData.deploy_permission" :processing-services="workflowMoreInfoData.processing_services" :template-id="workflowData.workflow_template ? workflowData.workflow_template.id : null" :ticket-id="workflowData.ticket_id" :deploy-envs="workflowData.deploy_envs" :step-id="currentStepId" @callback="init" />
    <workflow-relation-table v-show="activeKey === '6'" :data="workflowMoreInfoData.relation_workflow" />
    <workflow-stop-modal ref="workflowStopModalRef" @ok="onReload" />
    <workflow-modify-modal ref="workflowModifyModalRef" @ok="onReload" />
    <test-report-modal :is-show="reportVisible" :workflow-id="workflowId" :title="workflowData.title + '#测试报告'" :workflow-users="workflowData.workflow_users" :story-list="workflowMoreInfoData.story_list" :test-plans="planTableData" @cancel="reportModalCancel" />
    <workflow-sociated ref="sociated" @reload="onReload" />
    <accurate-info-modal ref="accurateInfoModalRef" />
    <config-confirm-modal ref="configConfirmModalRef" :workflow-id="workflowId" />
    <cover-report ref="covereportref" />
    <a-back-top />
  </div>
</template>
<script>
import { workflowStatus } from '@/utils/dictionary';
import { workflowDetail, workflowMoreInfo, workflowTestPlans, dissociationWorkflow } from '@/api/project/workflow';

import CoverReport from './components/CoverReport';
import AccurateInfoModal from './components/AccurateInfoModal';
import TaskList from '@/pages/project/workflow/components/TaskList';
import IssueList from '@/pages/project/workflow/components/IssueList';
import ProblemList from '@/pages/project/workflow/components/ProblemList';
import WorkflowMove from '@/pages/project/workflow/components/WorkflowMove';
import IssueBasicList from '@/pages/project/issue/components/IssueBasicList';
import WorkflowSteps from '@/pages/project/workflow/components/WorkflowSteps';
import WorkflowRelease from '@/pages/project/workflow/components/WorkflowRelease';
import TestReportModal from '@/pages/project/workflow/components/TestReportModal';
import WorkflowSociated from '@/pages/project/workflow/components/WorkflowSociated';
import WorkflowChangelog from '@/pages/project/workflow/components/WorkflowChangelog';
import WorkflowStopModal from '@/pages/project/workflow/components/WorkflowStopModal';
import ConfigConfirmModal from '@/pages/project/workflow/components/ConfigConfirmModal';
import WorkflowModifyModal from '@/pages/project/workflow/components/WorkflowModifyModal';
import WorkflowRelationTable from '@/pages/project/workflow/components/WorkflowRelationTable';
import WorkflowDetailService from '@/pages/project/workflow/components/WorkflowDetailService';
import WorkflowDetailCollapse from '@/pages/project/workflow/components/WorkflowDetailCollapse';

export default {
  components: {
    TaskList,
    IssueList,
    CoverReport,
    ProblemList,
    WorkflowMove,
    WorkflowSteps,
    IssueBasicList,
    WorkflowRelease,
    TestReportModal,
    WorkflowSociated,
    AccurateInfoModal,
    WorkflowChangelog,
    WorkflowStopModal,
    ConfigConfirmModal,
    WorkflowModifyModal,
    WorkflowRelationTable,
    WorkflowDetailService,
    WorkflowDetailCollapse
  },
  data() {
    return {
      coverageInfos: [],
      key: 0,
      loading: true,
      workflowStatus,
      reportVisible: false,
      onlineAccVisible: false,
      coverInfo: false,
      commits: '',
      url: '',
      activeKey: '0',
      projectId: parseInt(this.$route.params.project_id) || null,
      workflowId: parseInt(this.$route.query.workflowId) || null,
      workflowData: {
        workflow_steps: [],
        status: {
          value: null
        }
      },
      workflowMoreInfoData: {
        relation_workflow: [],
        content: [],
        description: [],
        apollo_address: [],
        sql_address: [],
        redis_change: [],
        services: [],
        bug_list: [],
        reject_bug_list: [],
        processing_services: [],
        problem_list: []
      },
      bugNumTotal: 0,
      bugListTotal: [],
      currentStepId: null,
      planTableData: []
    };
  },
  computed: {
    modifyStatus() {
      return !this.workflowData.modify_permission || [2, 3].includes(this.workflowData.status.value);
    },
    workflowLink() {
      return (project_id, workflow_id) => {
        const route = this.$router.resolve({
          name: 'page:project:workflow:detail',
          params: { project_id: project_id },
          query: { workflowId: workflow_id }
        });
        return route.href;
      };
    },
    /**
     * 计算是否展示精准测试按钮
     * 1. 当前流程为任务交付流程、HotFix流程
     * 2. 当前流程进度不为大于0(不是提审阶段)
     * 3. 当前流程关联的服务中包含精准测试服务
     */
    showAccurate() {
      return [2, 13].includes(this.workflowData.workflow_template.id) && this.workflowData.progress > 0 && this.workflowMoreInfoData.services.some(item => item.special_tests.includes(1));
    }
  },
  created() {
    if (this.workflowId !== null) {
      this.getWorkFlowData();
    } else {
      this.$router.push({ name: 'page:project:workflow:list' });
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    // 获取工作流详情
    getWorkFlowData() {
      this.loading = true;
      workflowDetail({ project_id: this.projectId, workflow_id: this.workflowId })
        .then(res => {
          this.init();
          this.$refs.changelog.getWorkflowChangelog();
          this.workflowData = res.data;
          this.planTableData = this.workflowData.workflow_current_step.all_plans;
          this.currentStepId = res.data.step_id;
          this.loading = false;
        })
        .catch(res => {
          this.loading = false;
          if (res.code === 4004) {
            this.$notification.info({
              message: '您访问的流程不存在',
              description: '已为您跳转至流程列表页'
            });
            this.$router.push({ name: 'page:project:workflow:list' });
          }
        });
    },
    getWorkflowTestPlans() {
      workflowTestPlans({ project_id: this.projectId, workflow_id: this.workflowId }).then(resp => {
        this.planTableData = resp.data.items;
      });
    },

    init() {
      this.timer = setInterval(() => {
        this.getWorkflowMoreInfo();
      }, 5000);
      this.getWorkflowMoreInfo();
    },

    viewCoverInfo() {
      window.open(this.url);
    },

    // 获取工作流更多信息
    getWorkflowMoreInfo() {
      workflowMoreInfo({ project_id: this.projectId, workflow_id: this.workflowId })
        .then(res => {
          this.workflowMoreInfoData = res.data;
          // this.bugNumTotal = this.workflowMoreInfoData.bug_list.length + this.workflowMoreInfoData.reject_bug_list.length;
          this.bugListTotal = this.workflowMoreInfoData.bug_list.concat(this.workflowMoreInfoData.reject_bug_list);
          this.bugNumTotal = new Set(this.bugListTotal.map(bug => bug.id)).size;
          if (res.data.deploying !== true) {
            clearInterval(this.timer);
          }
          this.key++;
        })
        .catch(() => {
          clearInterval(this.timer);
        });
    },

    onReload() {
      this.getWorkFlowData();
      this.getWorkflowMoreInfo();
      this.$refs.changelog.getWorkflowChangelog();
    },

    // 终止工作流
    onStop() {
      this.$nextTick(() => {
        this.$refs.workflowStopModalRef.onOpen(this.workflowId, this.projectId);
      });
    },

    // 编辑工作流
    onEdit() {
      this.$nextTick(() => {
        this.$refs.workflowModifyModalRef.onOpen(this.workflowId, this.projectId);
      });
    },

    onTestReport() {
      this.reportVisible = true;
    },

    reportModalCancel() {
      this.reportVisible = false;
    },

    /**
     * 点击生产对比
     */
    onOnlineAccurate() {
      this.$nextTick(() => {
        this.$refs.accurateInfoModalRef.open(this.workflowId, this.workflowMoreInfoData.services);
      });
    },

    getCoverInfo() {
      this.$refs.covereportref.open(this.url);
    },
    // 关闭弹框的回调
    close(type = 'close') {
      this.stopVisible = false;
      this.editVisible = false;
      if (type === 'close') {
        this.onReload();
      }
    },

    // 点击快速创建流程
    onFastCreate() {
      this.$router.push({
        name: 'page:project:workflow:create',
        query: { workflowId: this.workflowId }
      });
    },

    onSociatedWorkflow() {
      this.$refs['sociated'].onOpen(this.workflowId);
    },

    onDisassociation() {
      const self = this;
      this.$confirm({
        title: '请确认是否解除流程关联',
        okText: '确认',
        okType: 'primary',
        cancelText: '取消',
        onOk() {
          dissociationWorkflow({ project_id: self.projectId, workflow_id: self.workflowId }).then(() => {
            self.$message.success('流程解除关联成功');
            self.onReload();
          });
        }
      });
    },
    onConfigConfirmItem() {
      this.$nextTick(() => {
        this.$refs.configConfirmModalRef.onOpen();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.workflow-info {
  margin-bottom: 16px;
}

.workflow-descriptions-title {
  line-height: 28px;
  font-size: 14px;
  font-weight: bold;
}

.workflow-changelog {
  margin-top: 16px;
  background-color: #fff;
  padding: 8px 16px;
}

/deep/.workflow-info {
  margin: -16px -16px 16px -16px;

  .ant-divider-horizontal {
    margin: 8px 0px;
  }

  .ant-card-body {
    padding: 16px 16px 0 16px;
  }

  .ant-page-header {
    padding: 0;
  }

  .ant-descriptions-vertical {
    .ant-descriptions-row > th,
    .ant-descriptions-row > td {
      padding-bottom: 8px;
    }
  }

  .ant-descriptions-title {
    font-size: 14px;
    margin-bottom: 4px;
    line-height: 24px;
  }
}

/deep/.ant-page-header-footer {
  margin-top: 8px;

  .ant-tabs-bar .ant-tabs-nav .ant-tabs-tab {
    font-size: 14px;
    font-weight: bold;
  }
}

.head-example {
  display: inline-block;
  padding-right: 8px;
  // font-size: 16px;
}

/deep/.ant-badge-count {
  height: 16px;
  min-width: 16px;
  line-height: 16px;
  font-size: 8px;
  padding: 0 3px;
  background-color: #1890ff;
}

/deep/.badge-info > .ant-badge-count {
  background-color: #1890ff;
}

/deep/.badge-warning > .ant-badge-count {
  background-color: #faad14;
}

/deep/.ant-collapse-header {
  background: #f9f9f9;
}
.issues-collapse-panel {
  background: #fff;
  border-radius: 4px;
  margin-bottom: 24px;
  border: 0;
  overflow: hidden;
}
.gold-span {
  border: 1px solid green;
  color: green;
  padding: 4px;
  border-radius: 8px;
  font-size: 11px;
}

/deep/ .page-header_title {
  max-width: 50vw;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis; /* 文本溢出显示省略号 */
  white-space: nowrap; /* 文本不会换行 */
  vertical-align: bottom; /* 处理inline-block导致的元素上浮问题 */
}
</style>
